import React from 'react'
import { Link } from 'react-router-dom'

const Header = () => {
  return (
    <div>
       <div className="header-top-one">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="header-top-inner">
                            <div className="left-information-area">
                                {/* <p className="left-top">Using user feedback to creat a million dollar</p> */}
                                <div className="location-area">
                                    <i className="fa-light fa-location-dot"></i>
                                    <Link to= "#">Jaipur 302021 </Link>
                                </div>
                                <div className="working-time">
                                    <i className="fa-light fa-clock"></i>
                                    <p>Working Hours: 9:00 AM – 7:00 PM (Monday - Friday) </p>
                                </div>
                            </div>
                            <div className="right-header-top">
                                <div className="social-area-transparent">
                                    <span>Follow on</span>
                                    <Link to="https://www.facebook.com/starparthexamination/"><i className="fa-brands fa-facebook-f"></i></Link>
                                    <Link to="https://x.com/Starparthtech"><i className="fa-brands fa-twitter"></i></Link>
                                    <Link to="#"><i className="fa-brands fa-linkedin-in"></i></Link>
                                    <Link to="#"><i className="fa-brands fa-pinterest-p"></i></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Header